import { render, staticRenderFns } from "./BillRecord.vue?vue&type=template&id=d748e816&scoped=true&"
import script from "./BillRecord.vue?vue&type=script&lang=js&"
export * from "./BillRecord.vue?vue&type=script&lang=js&"
import style0 from "./BillRecord.vue?vue&type=style&index=0&id=d748e816&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d748e816",
  null
  
)

export default component.exports